import * as schema from '@fullstory/client-api';

const equivalentOps: Map<schema.SearchOperator, schema.SearchOperator> = new Map([
  // Needed for at least EventTargetText since it's persisted with either (== OR is).
  [schema.SearchOperator.SEARCH_OP_EQ, schema.SearchOperator.SEARCH_OP_IS],

  // Needed for at least UserAppKey since some are persisted with (><).
  [schema.SearchOperator.SEARCH_OP_OLD_SW, schema.SearchOperator.SEARCH_OP_SW],
]);

function equalDocumentCriterion(
  input: schema.DocumentCriterion,
  expected: schema.DocumentCriterion,
  loose: boolean = false,
): boolean {
  if (input.Field != expected.Field) {
    return false;
  }

  if (input.Op != expected.Op) {
    if (!loose) {
      return false;
    }

    const mutated = equivalentOps.get(input.Op);
    if (mutated === undefined || mutated != expected.Op) {
      return false;
    }
  }

  return (
    JSON.stringify(maybeUnwrapValue(input.Value)) ==
    JSON.stringify(maybeUnwrapValue(expected.Value))
  );
}

export function equalDocumentCriteria(
  input: schema.DocumentCriterion[],
  expected: schema.DocumentCriterion[],
  loose: boolean = false,
): boolean {
  if (input.length != expected.length) {
    return false;
  }

  return input.every((_, i) => equalDocumentCriterion(input[i], expected[i], loose));
}

export function copyCriterion(c: schema.DocumentCriterion): schema.DocumentCriterion {
  return {
    Field: c.Field,
    Op: c.Op,
    Value: c.Value,
  };
}

export function copyCriteria(c: schema.DocumentCriterion[]): schema.DocumentCriterion[] {
  return c.map(copyCriterion);
}

export function maybeUnwrapValue(v: unknown): unknown {
  if (v instanceof Array && v.length == 1) {
    return v[0];
  }
  return v;
}

export function maybeWrapValue(v: unknown): unknown {
  if (!(v instanceof Array)) {
    return [v];
  }
  return v;
}
